// extracted by mini-css-extract-plugin
export default {"appbar":"CustomerLayout_appbar__jcS8q","main":"CustomerLayout_main__gvWMz","content":"CustomerLayout_content__4yvMX"};